import { NgModule } from "@angular/core";
import { KwikUISearchFilterPipe } from "./search-filter.pipe";

@NgModule({
  declarations: [KwikUISearchFilterPipe],
  exports: [KwikUISearchFilterPipe]
})
export class KwikUISearchFilterPipeModule {}
